<template>
  <div>
    <div class="candidate-navbar" style="background-color: #3b425d">
      <button
        type="button"
        style="background-color: #18c58b; color: #fff"
        @click="gotToPage"
        v-if="isShowOnBoardData"
      >
        報到資料
      </button>
      <button
        type="button"
        style="background-color: #18c58b; color: #fff"
        @click="$common.downloadPersonnelInformationPDF(resumeType, matchId)"
      >
        下載 PDF
      </button>
      <a href="javascript:void(0)" @click.prevent="$router.go(-1)">返回</a>
    </div>

    <div class="step-page">
      <h3 class="mb-3 text-center" style="color: #fff">人事資料表</h3>

      <el-tabs
        v-model="activeName"
        :tab-position="windowWidth > 1024 ? 'left' : 'top'"
        class="tab-component"
      >
        <el-tab-pane label="面談背景資料" name="面談背景資料" lazy>
          <div class="step-content no-bg mt-3">
            <WorkedInfo
              :source="'personnelInformation'"
              :matchId="matchId"
              :key="workedInfoKey"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="基本資料" name="基本資料" lazy>
          <div class="step-content no-bg mt-3">
            <BaseInfo
              ref="baseInfo"
              :source="'personnelInformation'"
              :matchId="matchId"
              :key="baseInfoKey"
              :changePage="changePage"
              :person="person"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="學歷" name="學歷" lazy>
          <div class="step-content no-bg">
            <div class="step-tip mb-2">
              **
              請至少提供一項已經修業完成的學歷，並從最高學歷開始填寫，且至少提供一項已經修業完成的學歷，而若資料庫中無您的母校，請直接填寫校名。
            </div>
            <Education
              :source="'personnelInformation'"
              :matchId="matchId"
              :key="educationKey"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="工作經歷" name="工作經歷" lazy>
          <div class="step-content no-bg">
            <div class="step-tip mb-2">
              **
              請從最近一份工作經歷開始填起，「薪資」請填寫阿拉伯數字，例如：「29,000」。
            </div>
            <WorkExperience
              :source="'personnelInformation'"
              :matchId="matchId"
              :key="workExperienceKey"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="專業技能" name="專業技能" lazy>
          <div class="step-content no-bg mt-3">
            <Skill
              :source="'personnelInformation'"
              :matchId="matchId"
              :key="skillKey"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="活動經驗" name="活動經驗" lazy>
          <div class="step-content no-bg mt-3">
            <Activity
              :source="'personnelInformation'"
              :matchId="matchId"
              :key="activityKey"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="語言能力" name="語言能力" lazy>
          <div class="step-content no-bg">
            <div class="step-tip mb-2">
              * 請用優、良、可、劣四個等級來評比自己聽、說、讀、寫的能力。
            </div>
            <Language
              :source="'personnelInformation'"
              :matchId="matchId"
              :key="languageKey"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="工作配合" name="工作配合" lazy>
          <div class="step-content no-bg mt-3">
            <WorkCooperation
              :source="'personnelInformation'"
              :matchId="matchId"
              :key="workCooperationKey"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="面試情況" name="面試情況" lazy>
          <div class="step-content no-bg mt-3">
            <InterviewStatus
              :source="'personnelInformation'"
              :matchId="matchId"
              :key="interviewStatusKey"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="職缺需求" name="職缺需求" lazy>
          <div class="step-content no-bg mt-3">
            <WorkConsideration
              :source="'personnelInformation'"
              :matchId="matchId"
              :key="workConsiderationKey"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="保密義務" name="保密義務" lazy>
          <div class="step-content no-bg">
            <div class="step-tip mb-2">
              註：「保密義務」是指您對於前雇主的機密資訊負有保密責任，離職之後不得繼續使用、揭露或持有。<br />
              **
              提醒您，以下說明內容應真確詳實，並與您所簽訂的保密義務條款相同。
            </div>
            <Confidentiality
              :source="'personnelInformation'"
              :matchId="matchId"
              :key="confidentialityKey"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="禁止條款" name="禁止條款" lazy>
          <div class="step-content no-bg">
            <div class="step-tip mb-2">
              註：「競業禁止」是指您曾與前雇主約定，在離職後的一定期間內，不能受雇於與該前雇主之營業性質相同或類似的工作。<br />
              **
              提醒您，以下說明內容應真確詳實，並與您所簽訂的競業禁止條款相同。
            </div>
            <NonCompete
              :source="'personnelInformation'"
              :matchId="matchId"
              :key="nonCompeteKey"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="智財" name="智財" lazy>
          <div class="step-content no-bg mt-3">
            <IntellectualProperty
              :source="'personnelInformation'"
              :matchId="matchId"
              :key="intellectualPropertyKey"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="自傳" name="自傳" lazy>
          <div class="step-content no-bg">
            <Autobiography
              :source="'personnelInformation'"
              :matchId="matchId"
              :key="autobiographyKey"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import WorkedInfo from "@/components/customize/Front/IDL/WorkedInfo";
import BaseInfo from "@/components/customize/Front/IDL/BaseInfo";
import Education from "@/components/customize/Front/IDL/Education";
import WorkExperience from "@/components/customize/Front/IDL/WorkExperience";
import Skill from "@/components/customize/Front/IDL/Skill";
import Activity from "@/components/customize/Front/IDL/Activity";
import Language from "@/components/customize/Front/IDL/Language";
import Autobiography from "@/components/customize/Front/IDL/Autobiography";
import WorkCooperation from "@/components/customize/Front/IDL/WorkCooperation";
import InterviewStatus from "@/components/customize/Front/IDL/InterviewStatus";
import WorkConsideration from "@/components/customize/Front/IDL/WorkConsideration";
import Confidentiality from "@/components/customize/Front/IDL/Confidentiality";
import NonCompete from "@/components/customize/Front/IDL/NonCompete";
import IntellectualProperty from "@/components/customize/Front/IDL/IntellectualProperty";

export default {
  name: "IDLPersonnelInformation",

  components: {
    WorkedInfo,
    BaseInfo,
    Education,
    WorkExperience,
    Skill,
    Activity,
    Language,
    Autobiography,
    WorkCooperation,
    InterviewStatus,
    WorkConsideration,
    Confidentiality,
    NonCompete,
    IntellectualProperty,
  },

  data() {
    return {
      activeName: "面談背景資料",
      resumeType: "IDL",
      matchId: null,
      isShowOnBoardData: false,
      changePage: false,

      workedInfoKey: 0,
      baseInfoKey: 0,
      educationKey: 0,
      workExperienceKey: 0,
      skillKey: 0,
      activityKey: 0,
      languageKey: 0,
      autobiographyKey: 0,
      workCooperationKey: 0,
      interviewStatusKey: 0,
      workConsiderationKey: 0,
      confidentialityKey: 0,
      nonCompeteKey: 0,
      intellectualPropertyKey: 0,
      windowWidth: 0,
    };
  },

  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    // 轉跳至報到資料
    gotToPage() {
      this.changePage = true;
      this.$refs.baseInfo.saveBaseInfo();
    },
  },

  watch: {
    activeName: function (newVal) {
      switch (newVal) {
        case "面談背景資料":
          this.workedInfoKey += 1;
          break;
        case "基本資料":
          this.baseInfoKey += 1;
          break;
        case "學歷":
          this.educationKey += 1;
          break;
        case "工作經歷":
          this.workExperienceKey += 1;
          break;
        case "專業技能":
          this.skillKey += 1;
          break;
        case "活動經驗":
          this.activityKey += 1;
          break;
        case "語言能力":
          this.languageKey += 1;
          break;
        case "工作配合":
          this.workCooperationKey += 1;
          break;
        case "面試情況":
          this.interviewStatusKey += 1;
          break;
        case "職缺需求":
          this.workConsiderationKey += 1;
          break;
        case "保密義務":
          this.confidentialityKey += 1;
          break;
        case "禁止條款":
          this.nonCompeteKey += 1;
          break;
        case "智財":
          this.intellectualPropertyKey += 1;
          break;
        case "自傳":
          this.autobiographyKey += 1;
          break;
        default:
          this.workedInfoKey += 1;
      }
    },
  },

  created() {
    this.matchId = this.$route.query.matchId;
    this.person = JSON.parse(this.$route.query.personData);
    this.isShowOnBoardData = this.$route.query.isShowOnBoardData ? this.$route.query.isShowOnBoardData.toLowerCase() === "true" : "false";
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
};
</script>

<style lang="scss" scoped>
.step-tip {
  color: #fff;
  font-size: 0.85em;
}

/deep/ .el-tabs__content {
  &::-webkit-scrollbar {
    width: 7px;
  }

  &::-webkit-scrollbar-button {
    background: transparent;

    border-radius: 4px;
  }

  &::-webkit-scrollbar-track-piece {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;

    background-color: rgba(0, 0, 0, 0.4);

    border: 1px solid slategrey;
  }

  &::-webkit-scrollbar-track {
    box-shadow: transparent;
  }

  @media screen and (min-width: 768px) {
    height: calc(100vh - 175px);
    overflow: auto;
  }
}

/deep/ .tab-component {
  .el-tabs__item {
    color: #fff;

    &.is-active {
      color: #22c59a;
    }
  }

  .el-tabs__active-bar {
    background-color: #22c59a;
  }

  .important-table {
    width: 90%;
    max-width: 680px;
    margin: 0 auto;

    th {
      color: #fff;
      padding: 10px;
      text-align: center;
    }
    td {
      padding: 10px;
      input,
      select {
        border: none;
        border-radius: 25px;
        width: 100%;
        line-height: 30px;
        height: 30px;
        padding: 0 10px;
      }
    }
  }
}

/deep/ .el-input--prefix .el-input__inner {
  padding-left: 30px !important;
}
</style>
